import Prepress from '@/views/Prepress/Index.vue'

export default [
    {
        path: '/prepress',
        name: 'prepress',
        component: Prepress,
        redirect: { name: 'prepressJobs' },
        meta: {
            title: 'prepress.root.pageTitle',
            menuRendered: true,
            menuTitle: 'prepress.root.menuTitle',
            icon: 'mdi-tray-full'
        },
        children: [
            {
                path: '/prepress/plate-orders',
                name: 'prepressPlateOrders',
                component: () => import('@/views/Prepress/PlateOrders/Index.vue'),
                meta: {
                    title: 'prepress.plateOrders.pageTitle',
                    menuRendered: true,
                    menuTitle: 'prepress.plateOrders.menuTitle',
                    requiresAuth: true,
                    permission: 'plate_orders'
                }
            },
            {
                path: '/prepress/jobs',
                name: 'prepressJobs',
                component: () => import('@/views/Prepress/Jobs/Index.vue'),
                meta: {
                    title: 'prepress.jobs.pageTitle',
                    menuRendered: true,
                    menuTitle: 'prepress.jobs.menuTitle',
                    requiresAuth: true,
                    permission: 'prepress_reports'
                }
            }
        ]
    }
]
